 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"authorization":"authorization","categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3":"categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3","categories~index~sdIndex":"categories~index~sdIndex","categories":"categories","index":"index","sdIndex":"sdIndex","comCart":"comCart","groupBuying":"groupBuying","groupBuyingJoin":"groupBuyingJoin","groupBuyingList":"groupBuyingList","home~integralDetail":"home~integralDetail","home":"home","integralDetail":"integralDetail","integral":"integral","selfAddr":"selfAddr","signature":"signature","zntGoodList":"zntGoodList","channelShopNew":"channelShopNew","comCartAdd":"comCartAdd","deposit":"deposit","exception":"exception","groupBuyingDetail":"groupBuyingDetail","groupBuyingOrders":"groupBuyingOrders","groupBuyingOver":"groupBuyingOver","orderConfirmation":"orderConfirmation","orderCredential":"orderCredential","orderLogistics":"orderLogistics","orderPickUp":"orderPickUp","qa":"qa","selfAddrAdd":"selfAddrAdd","vip":"vip","ywb":"ywb","zntShopList":"zntShopList"}[chunkId]||chunkId) + "." + {"authorization":"5f5539f6","categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3":"23efa30e","categories~index~sdIndex":"e9b9dc22","categories":"dde31c72","index":"db87185e","sdIndex":"99a06923","comCart":"e0234bd2","groupBuying":"d29d5ad9","groupBuyingJoin":"3de93e5c","groupBuyingList":"84c5cb0e","home~integralDetail":"cbdf41fd","home":"d5272085","integralDetail":"b4b763e9","integral":"0fe9205c","selfAddr":"5759685d","signature":"65c11b56","zntGoodList":"5a819ffd","channelShopNew":"1118667a","chunk-1b3da7be":"db6d3ef4","chunk-2d0b68f8":"f6022f3e","chunk-9580746a":"674052b6","comCartAdd":"ce463b90","deposit":"1f008f77","exception":"4676d155","groupBuyingDetail":"7d3db52d","groupBuyingOrders":"b97d4901","groupBuyingOver":"5a1d0934","orderConfirmation":"4da8d0a1","orderCredential":"562bdee1","orderLogistics":"85c7d986","orderPickUp":"94812130","qa":"3d1674e0","selfAddrAdd":"f79eb1c2","vip":"3b989068","ywb":"906dc608","zntShopList":"79580903"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"authorization":1,"categories~index~sdIndex":1,"categories":1,"index":1,"sdIndex":1,"comCart":1,"groupBuying":1,"groupBuyingJoin":1,"groupBuyingList":1,"home~integralDetail":1,"home":1,"integralDetail":1,"integral":1,"selfAddr":1,"signature":1,"zntGoodList":1,"channelShopNew":1,"chunk-1b3da7be":1,"chunk-9580746a":1,"comCartAdd":1,"deposit":1,"exception":1,"groupBuyingDetail":1,"groupBuyingOrders":1,"groupBuyingOver":1,"orderConfirmation":1,"orderCredential":1,"orderLogistics":1,"orderPickUp":1,"qa":1,"selfAddrAdd":1,"vip":1,"ywb":1,"zntShopList":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"authorization":"authorization","categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3":"categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3","categories~index~sdIndex":"categories~index~sdIndex","categories":"categories","index":"index","sdIndex":"sdIndex","comCart":"comCart","groupBuying":"groupBuying","groupBuyingJoin":"groupBuyingJoin","groupBuyingList":"groupBuyingList","home~integralDetail":"home~integralDetail","home":"home","integralDetail":"integralDetail","integral":"integral","selfAddr":"selfAddr","signature":"signature","zntGoodList":"zntGoodList","channelShopNew":"channelShopNew","comCartAdd":"comCartAdd","deposit":"deposit","exception":"exception","groupBuyingDetail":"groupBuyingDetail","groupBuyingOrders":"groupBuyingOrders","groupBuyingOver":"groupBuyingOver","orderConfirmation":"orderConfirmation","orderCredential":"orderCredential","orderLogistics":"orderLogistics","orderPickUp":"orderPickUp","qa":"qa","selfAddrAdd":"selfAddrAdd","vip":"vip","ywb":"ywb","zntShopList":"zntShopList"}[chunkId]||chunkId) + "." + {"authorization":"63c917e7","categories~comCart~groupBuying~groupBuyingJoin~groupBuyingList~home~index~integral~integralDetail~sd~fd578aa3":"31d6cfe0","categories~index~sdIndex":"a9b9cbe1","categories":"bb4b08db","index":"5a37815d","sdIndex":"773efe40","comCart":"f2949ddd","groupBuying":"0e50713e","groupBuyingJoin":"37287a04","groupBuyingList":"a9913f7f","home~integralDetail":"0876e92f","home":"04fdb519","integralDetail":"d4ef11b5","integral":"78bc056a","selfAddr":"aa0778c7","signature":"eb9f7b1a","zntGoodList":"16d2d3b7","channelShopNew":"7f02fa65","chunk-1b3da7be":"727194f0","chunk-2d0b68f8":"31d6cfe0","chunk-9580746a":"9794e1bb","comCartAdd":"88502c9e","deposit":"0714f764","exception":"fce9ea9c","groupBuyingDetail":"899f2745","groupBuyingOrders":"d277c3c0","groupBuyingOver":"ab62da14","orderConfirmation":"ff503493","orderCredential":"23b12f01","orderLogistics":"5e29eb52","orderPickUp":"aabe5c35","qa":"36660d26","selfAddrAdd":"62b75717","vip":"cafc5597","ywb":"6514454e","zntShopList":"50ad4b21"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/vm/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
